/**
 * Miscelanee bootstrap:
 *   - `.testi-group nav` navMenu pe `.testi` panels
 *   - `.layer-3 .pagination` navMenu pe `.group` panels
 *   - `a[href="#"]` preventDefault global (anchor-uri inert)
 *
 * Port 1:1 din legacy common.js lines 2597, 2671, 2677-2679.
 */

import { $ } from '../core/selector.js';

export function initMisc(): void {
    ($('.testi-group nav') as Element | null)?.navMenu('a', '.testi');
    ($('.layer-3 .pagination') as Element | null)?.navMenu('a', '.group');

    $('a[href="#"]', true).on('click', function (e: Event) {
        e.preventDefault();
    });
}
